import { store } from "../../app";
import {
  changeForceTokenReFetch,
  changeIsTokenRefreshing,
} from "../../user/store/userSlice";

const TOKEN_REFRESH_TIMEOUT_MS = 10000;

// Gated on the logged-in user rather than the OIDC-only refresh cookie, so a
// 401 refreshes in both Auth0 and OIDC modes; without a user, a 401 on an
// unauthenticated request would cascade into a fake logout.
export const canRefreshToken = () => store.getState().userReducer.user !== null;

export const requestTokenRefresh = () => {
  store.dispatch(changeForceTokenReFetch(true));
  store.dispatch(changeIsTokenRefreshing(true));
};

/**
 * Resolves when `isTokenRefreshing` becomes false, or rejects on timeout.
 */
export const waitForTokenRefresh = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!store.getState().userReducer.isTokenRefreshing) {
      resolve();
      return;
    }

    // Must stay `let`: the timeout callback below references `unsubscribe`,
    // while the subscriber references `timeout`, so neither can be declared
    // first as a const.
    // eslint-disable-next-line prefer-const
    let unsubscribe: () => void;

    const timeout = setTimeout(() => {
      unsubscribe?.();
      reject(new Error("Token refresh timed out"));
    }, TOKEN_REFRESH_TIMEOUT_MS);

    unsubscribe = store.subscribe(() => {
      if (!store.getState().userReducer.isTokenRefreshing) {
        clearTimeout(timeout);
        unsubscribe();
        resolve();
      }
    });
  });
};
